import { render, staticRenderFns } from "./ModalPatternPicker.vue?vue&type=template&id=96f37540&scoped=true&"
import script from "./ModalPatternPicker.vue?vue&type=script&lang=js&"
export * from "./ModalPatternPicker.vue?vue&type=script&lang=js&"
import style0 from "./ModalPatternPicker.vue?vue&type=style&index=0&id=96f37540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f37540",
  null
  
)

export default component.exports